'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _languageCommon = require('@wh/language-common');

var _reduxDeviceDetection = require('@wh/redux-device-detection');

var _timezone = require('./timezone');

var _timezone2 = _interopRequireDefault(_timezone);

var _currentUrl = require('./currentUrl');

var _currentUrl2 = _interopRequireDefault(_currentUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var settings = (0, _extends3.default)({}, _languageCommon.reducers, _reduxDeviceDetection.reducers, {
    timezone: _timezone2.default,
    currentUrl: _currentUrl2.default
});

exports.default = {
    settings: settings
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-global-settings/dist/main/reducers/index.js
// module id = 522
// module chunks = 0